<!--
 * @Author: xuquantong
 * @Date: 2023-12-20 14:34:16
 * @LastEditors: xuquantong
 * @LastEditTime: 2023-12-20 14:17:17
 * @Description: 用于新版评价/追评/提问/回答成功页
-->
<template>
  <div class="success-list-item">
    <div class="item-image">
      <img class="img" v-if="img" :src="img" />
    </div>
    <div class="item-content">
      <div class="title" v-if="title">{{ title }}</div>
      <div class="subtitle" v-if="subTitle" v-html="subTitle"></div>
    </div>
    <div class="item-action">
      <v-button type="primary" size="small" @click="handleClick">{{ btnText }}</v-button>
    </div>
  </div>
</template>

<script>
import create from '../create'
export default create({
  name: 'successitem',
  props: {
    img: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    btnText: {
      type: String,
      default: '去回答'
    }
  },
  methods: {
    handleClick() {
      this.$emit('handleClick')
    }
  }
})
</script>

<style lang="scss" scoped src="./index.scss"></style>
